import { Component, OnInit } from '@angular/core';
import { CommonService } from 'app/services/common.service';

@Component({
  selector: 'app-top-cards',
  templateUrl: './top-cards.component.html',
  styleUrls: ['./top-cards.component.scss']
})
export class TopCardsComponent implements OnInit {

  topcardsCount: any;
  constructor(private commonService: CommonService) { }

  ngOnInit() {
    this.getTopCardsCount();
  }
  getTopCardsCount() {
    this.commonService.labelsCount().subscribe(result => {
      if (result.status === 1) {
        this.topcardsCount = result.data;
      }
    })
  }
}
